module.exports = __webpack_public_path__ + "static/media/second-step.831be804.jpeg";